<div class="dynamic-field form-button" [formGroup]="group">
  <button
    type="submit"
    mat-flat-button
    [disabled]="config.disabled || (isBusy$ | async)"
    [ngClass]="config.cssClass?.split(',')"
    class="outlined"
  >
    <div class="flex flex-row aic jcc">
      <div>
        {{ (isBusy$ | async) ? 'Loading....' : config.label }}
      </div>
    </div>
  </button>
</div>
<rx-spinner *ngIf="isBusy$ | async"></rx-spinner>
